import React from 'react';
import { useIntl } from 'react-intl';
import { IArtifact, IFile } from '../../interfaces/artifact.interfaces';
import styles from './attachmentList.module.scss';
import { CustomLink, IconButton } from '..';
import { formatBytes, getExtensionFromString } from '../../helpers';
import { AttachmentIcon } from '../../assets/images/svg/atachmenticon';
interface IAttachmentListProps {
    attachments: Array<IArtifact>;
    onAttachmentClicked: (attachment: IArtifact, file: IFile) => void;
    className?: string;
    id: string;
}

export const AttachmentList = ({
    onAttachmentClicked,
    id,
    className,
    attachments,
}: IAttachmentListProps): JSX.Element => {
    const renderExtendedInfo = (file: IFile): string => {
        return `(${getExtensionFromString(file.filename).toUpperCase()}, ${formatBytes(file.fileSize)})`;
    };

    const { formatMessage } = useIntl();

    const attachmentList = [...attachments];

    return (
        <div className={`${styles.attachmentListWrap} ${className}`}>
            <ul className={`${styles.attachmentList} p-0`}>
                {attachmentList.map((artifact, index) =>
                    artifact.files.map((file) => {
                        return (
                            <li key={id + file?.id + index} className="d-flex align-items-center">
                                <IconButton
                                    isRound
                                    size="small"
                                    aria-label={formatMessage({ id: 'EMAIL_HAS_ATTACHMENTS_LABEL' })}
                                    icon={<AttachmentIcon />}
                                />
                                <CustomLink
                                    variant="dark"
                                    title={file.filename}
                                    className="text-truncate w-100"
                                    disableContextMenu
                                    onClick={() => {
                                        onAttachmentClicked(artifact, file);
                                    }}
                                >
                                    <span className={`${styles.attachmentIcon} ${styles.attachmentText}`}>
                                        {file.filename} {renderExtendedInfo(file)}
                                    </span>
                                </CustomLink>
                            </li>
                        );
                    })
                )}
            </ul>
        </div>
    );
};
